import { SsrService } from '@/common/services/ssr/ssr.service';
import { isValid } from '@/common/utils/validation/common.utils';
import {
    MissingTranslationHandler,
    MissingTranslationHandlerParams,
} from '@ngx-translate/core';

export class ApiMissingTranslationHandler implements MissingTranslationHandler {
    constructor(private ssr: SsrService) {}

    handle(params: MissingTranslationHandlerParams) {
        if (this.ssr.isPlatformServer()) {
            return params.key;
        }
        let missingTranslations = JSON.parse(
            localStorage.getItem('missing-translations') as string,
        );
        if (!isValid(missingTranslations)) {
            missingTranslations = {};
        }
        missingTranslations[params.key] = '';
        localStorage.setItem(
            'missing-translations',
            JSON.stringify(missingTranslations),
        );
        return params.key;
    }
}
